import { useRef } from 'react';
import { useLocation } from 'react-router';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar } from 'antd';

import LogoSvg from '1_shared/assets/pictures/logo.svg';
import LogoMobileSvg from '1_shared/assets/pictures/logo-mobile.svg';
import LogoMIPSvg from '1_shared/assets/pictures/MIPv2.svg';
import { RoutePath } from '1_shared/config/routes';

import { ERoles } from '../../../1_shared/config/enums/ERoles';
import { useAuthContext } from '../../../app/module/lib/hooks/useAuthContext';
import { headerLinks } from '../config/headerLinks';

import { menuToggle } from './menu';

import 'app/styles/global/global.scss';
import './data-accordion.scss';
import './header.scss';
import { IClientsByInfo } from '../../../1_shared/api/services/configs/interfaces/adminService.interface';
import { pcProfileRoute } from '../../../1_shared/config/pcProfileRoute';

const Header = () => {
  const { logout, user, role } = useAuthContext();
  const navMain = useRef<any>();
  const navToggle = useRef<any>();
  const navigate = useNavigate();
  const location = useLocation();

  const userAvatar = user?.mediaContentResponse?.find(
    (el: any) => el.isPrimary,
  );
  const currentRole = localStorage.getItem('role');
  const RolesWithAvatar = [ERoles.Spec];
  const RolesWithName = [ERoles.Client];

  return (
    <header ref={navMain} className="header header--index">
      {/* на главной добавить класс header--index */}
      <nav className="header__nav container">
        <div className="header__top">
          <div className="header__logotypies">
            <Link to={RoutePath.MAIN} className="header__logo">
              <source media="(max-width: 1023px)" srcSet={LogoMobileSvg} />
              <img src={LogoSvg} alt="DoTherapy" height="39" />
            </Link>
            <a
              href="https://inpsycho.ru"
              target="_blank"
              rel="noopener noreferrer"
            >
              <source
                media="(max-width: 1023px)"
                srcSet={LogoMIPSvg}
                height={41}
                width={139}
              />
              <img src={LogoMIPSvg} alt="MIP-logo" width="145" />
            </a>
          </div>
          <button
            className="header__toggle"
            type="button"
            aria-label="Меню"
            ref={navToggle}
            onClick={() => menuToggle(navMain.current)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
        <div className="header__wrapper">
          <div className="header__nav-list-wrap">
            <ul className="header__nav-list" data-accordion="parent">
              {headerLinks.map(item =>
                item.isAccordion ? (
                  <li
                    key={item.label}
                    className="header__nav-item header__nav-item--dropdown"
                    data-accordion="element"
                  >
                    <a
                      href="/"
                      className="header__nav-link"
                      data-accordion="button"
                    >
                      {item.label}
                    </a>
                    <ul
                      className="header__nav-sublist"
                      data-accordion="content"
                    >
                      {item.children?.map(child => (
                        <li key={child.label} className="header__nav-subitem">
                          <Link to={child.url} className="header__nav-sublink">
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li key={item.label} className="header__nav-item">
                    <a
                      // href={item.url}
                      className="header__nav-link"
                      onClick={() => {
                        if (item.url === '#application') {
                          // @ts-ignore
                          ym(338452102, 'reachGoal', '15min_consultation', {
                            isAuthorize: !!user,
                            userId: user?.id ?? null,
                          });
                        }
                        if (item.url.includes('https')) {
                          window.location.href = item.url;
                        } else {
                          navigate(item.url, { state: location.state });
                        }
                      }}
                    >
                      {item.label}
                    </a>
                  </li>
                ),
              )}
            </ul>
          </div>
          <div>
            {user && currentRole ? (
              <ul className="header__nav-list" data-accordion="parent">
                <li
                  className="header__nav-item header__nav-item--dropdown"
                  data-accordion="element"
                >
                  <a
                    href="/"
                    className="header__nav-link--profile"
                    data-accordion="button"
                  >
                    {RolesWithAvatar.includes(currentRole as ERoles) && (
                      <Avatar
                        src={
                          userAvatar?.mediaContentResponse?.previewLink ||
                          user?.avatarUrl
                        }
                        size={20}
                      />
                    )}
                    {RolesWithName.includes(currentRole as ERoles) &&
                      `${!user?.nickname ? 'Аноним' : user?.nickname}`}
                    {currentRole === ERoles.Admin &&
                      `${user.firstName} ${(user as unknown as IClientsByInfo).lastName}`}
                  </a>
                  <ul className="header__nav-sublist" data-accordion="content">
                    <li className="header__nav-subitem">
                      <Link
                        to={pcProfileRoute?.[role] ?? '/'}
                        className="header__nav-sublink"
                      >
                        Профиль
                      </Link>
                    </li>
                    <li className="header__nav-subitem">
                      <button
                        className="header__logout"
                        onClick={() => {
                          if (logout) {
                            logout();
                            if (location.pathname !== RoutePath.ORDER) {
                              navigate(RoutePath.MAIN);
                            }
                          }
                        }}
                        type="button"
                      >
                        <span className="header__nav-sublink">Выход</span>
                      </button>
                    </li>
                  </ul>
                </li>
              </ul>
            ) : (
              <Link
                to={RoutePath.LOGIN}
                className="header__login"
                data-popup="popup-login"
              >
                Войти
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
